import { Avatar } from "@ui/Avatar";
import { Card } from "@ui/Card";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { Pill } from "@ui/Pill";
import { HStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { Show } from "solid-js";
import type { DiscoverySuggestedInfluencer } from "@/client";
import { creatorHref } from "../utils/creatorHref";

type Props = {
	creator: DiscoverySuggestedInfluencer;
};

const SubPill = (props: { type: "paid" | "free" }) => {
	const icon = props.type === "paid" ? "person" : "lock_open_right";
	const text = props.type === "paid" ? "Paid" : "Free";
	const theme = props.type === "paid" ? "purple" : "primary";
	return (
		<Pill theme={theme} size="xsmall">
			<Text family="mono" size="xsmall" weight="bold" color={theme}>
				<HStack align="center" spacing="small">
					<MaterialSymbol symbol={icon} relativeSize="smaller" />
					{text}
				</HStack>
			</Text>
		</Pill>
	);
};
export const CreatorCategoryCard = (props: Props) => {
	const href = () => creatorHref(props.creator.handle);

	return (
		<Card
			as="a"
			href={href()}
			class="askgvt-creator askgvt-creator--category"
			noPadding
		>
			<div class="askgvt-creator-cover" title={props.creator.name}>
				<Show when={props.creator.banner_url}>
					<img src={props.creator.banner_url ?? ""} alt="" />
				</Show>
			</div>
			<div class="askgvt-creator-head">
				<span class="askgvt-creator-avatar">
					<Avatar
						alt={props.creator.name ?? ""}
						src={props.creator.profile_picture_url ?? undefined}
						size="medium"
					/>
				</span>
				<HStack
					align="center"
					justify="space-between"
					spacing="small"
					fullWidth
				>
					<Text
						as="span"
						size="intermediate"
						weight="semi-bold"
						color="ink"
						ellipsis
						style={{ "min-width": 0 }}
					>
						{props.creator.name}
					</Text>

					<SubPill type={props.creator.is_paid ? "paid" : "free"} />
				</HStack>
				<Text family="mono" size="xsmall" color="fg3" ellipsis>
					@{props.creator.handle}
				</Text>
				<Show when={props.creator.bio ?? props.creator.positioning}>
					{(description) => (
						<Text size="small" color="fg3" class="askgvt-creator-bio">
							{description()}
						</Text>
					)}
				</Show>
			</div>
		</Card>
	);
};
